import { css } from 'styled-components';
import { breakpoints as BreakpointMap } from '@nib-components/theme';
export const breakpoint = (gte, lt) => {
  /* eslint-disable @typescript-eslint/no-explicit-any */return function (strings) {
    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }
    return function (_ref) {
      let {
        theme
      } = _ref;
      return _breakpoint(theme.breakpoints || BreakpointMap, gte, lt)(strings, ...interpolations);
    };
  };
};
export function _breakpoint(breakpoints, gte, lt) {
  if (typeof lt === 'undefined') {
    return _gte(breakpoints, gte);
  } else {
    return _between(breakpoints, gte, lt);
  }
}
export function _gte(breakpoints, name) {
  return withSingleCriteria(breakpoints, name, 'min-width');
}
export function _between(breakpoints, gte, lt) {
  const gteValue = getValueFromName(breakpoints, gte);
  const ltValue = getValueFromName(breakpoints, lt);
  /* eslint-disable @typescript-eslint/no-explicit-any */
  return function (strings) {
    for (var _len2 = arguments.length, interpolations = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }
    return css`
      @media (min-width: ${convertPxToEm(gteValue)}em) and (max-width: ${convertPxToEm(ltValue - 1)}em) {
        ${css(strings, ...interpolations)}
      }
    `;
  };
}
function withSingleCriteria(breakpoints, name, operator) {
  let offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  const value = getValueFromName(breakpoints, name);
  // special case for 0 to avoid wrapping styles in an unnecessary @media block
  if (operator === 'min-width' && value === 0) {
    /* eslint-disable @typescript-eslint/no-explicit-any */return function (strings) {
      for (var _len3 = arguments.length, interpolations = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        interpolations[_key3 - 1] = arguments[_key3];
      }
      return css(strings, ...interpolations);
    };
  }
  return function (strings) {
    for (var _len4 = arguments.length, interpolations = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      interpolations[_key4 - 1] = arguments[_key4];
    }
    return css`
      @media (${operator}: ${convertPxToEm(value + offset)}em) {
        ${css(strings, ...interpolations)}
      }
    `;
  };
}
function getValueFromName(breakpoints, name) {
  if (!(name in breakpoints)) {
    console.error(`breakpoint: Breakpoint "${name}" was not found.`);
    return 0;
  }
  return breakpoints[name];
}
function convertPxToEm(pixels) {
  // @media is always calculated off 16px regardless of whether the root font size is the default or not
  return pixels / 16;
}
export function map(value, mapValueToCSS) {
  return function (_ref2) {
    let {
      theme
    } = _ref2;
    return _map(theme.breakpoints || BreakpointMap, value, mapValueToCSS);
  };
}
export function _map(breakpoints, value, mapValueToCSS) {
  const values = value;
  if (values === null || typeof values !== 'object') {
    return mapValueToCSS(values);
  }
  return [mapValueToCSS(undefined), ...Object.keys(values).map(name => {
    const tag = _gte(breakpoints, name);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const val = values[name];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    const styles = tag([], [].concat(mapValueToCSS(val)));
    return styles;
  })];
}